import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { useShowErrorToast } from '@utils/formHelpers';
import { DefaultApiResp } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { InventoryRoutesRespSuccess } from '../types';
import { useQueryParams } from '@hooks/queryParams';

export const useCreateInventoryRoute = ({
  callback,
}: {
  callback: (data: InventoryRoutesRespSuccess) => void;
}) => {
  const { setParam } = useQueryParams();
  const queryClient = useQueryClient();
  const { showErrorToast } = useShowErrorToast();
  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<InventoryRoutesRespSuccess> =>
      queryFetch({
        url: 'routes_planner',
        opt: { method: 'POST' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success, data }) => {
      if (!success) return;
      await queryClient.refetchQueries({ queryKey: queryKeys.dropdowns.routes });
      setParam('routeId', data.id);
    },
    onSettled: (data) => {
      const { success, errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
      if (success) callback(data as InventoryRoutesRespSuccess);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
